// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__w1Z4i","list":"PatternAutocomplete_list__VWv7R"};